import { Link } from "react-router-dom";
import { RxArrowTopRight } from "react-icons/rx";

const Card = ({ id, title, img_link }) => {
	return (
		<div className="my-4 mb-4 mx-6 overflow-hidden border border-neutral-800 md:mx-5 lg:mb-8">

			<div className="relative w-full overflow-hidden bg-cover bg-no-repeat group shadow-inner">
				<img alt="event" src={img_link} className="h-80 w-96 object-cover ease-in-out duration-500 group-hover:scale-110 md:w-80 lg:h-96" />
				<Link to={`/${id}`} className="cursor-pointer">
					<div className="absolute inset-0 bg-gradient-to-t from-black flex flex-col justify-between">
						<div className="flex justify-end">
							<div className="text-white font-bold text-3xl pt-6 pr-5 ease-in-out duration-500 w-min group-hover:scale-110"><RxArrowTopRight size={40} /></div>
						</div>
						<p className="text-2xl font-semibold pb-6 pl-5 opacity-100 ease-in-out duration-500 group-hover:-translate-y-1">
							{title}
						</p>
					</div>
				</Link>
			</div>

		</div>
	);
};

export default Card;
